import { Clock, Instagram, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import Img from "@/components/Img";
import { useT, useLoc } from "@/lib/i18n";

const Item = ({ icon: I, children, testid }) => (
  <p data-testid={testid} className="flex items-start gap-2"><I className="mt-0.5 h-4 w-4 shrink-0 text-[#D9A066]" /><span>{children}</span></p>
);

export default function PropertyFooter({ p, findHref }) {
  const t = useT();
  const loc = useLoc();
  if (!p) return null;
  const wa = (p.whatsapp || "").replace(/\D/g, "");
  return (
    <footer data-testid="property-footer" className="mt-20 bg-[#1C1917] text-stone-300">
      <div className="mx-auto grid max-w-7xl gap-8 px-6 py-12 text-sm md:grid-cols-[1.3fr_1fr_1fr]">
        <div>
          {p.logo ? <span className="inline-block rounded-lg bg-white px-3 py-2"><Img src={p.logo} size="sm" alt={p.name} className="h-10 w-auto max-w-[200px] object-contain" /></span>
            : <span className="font-heading text-2xl font-bold text-white">{p.name}</span>}
          <p className="mt-3 max-w-sm text-stone-400">{loc(p, "footer_text") || `${p.area ? `${p.area}, ` : ""}${p.city}`}</p>
        </div>
        <div className="space-y-2">
          <p className="mb-1 font-semibold uppercase tracking-wide text-stone-500">{t("Lokasi")}</p>
          {p.address && <Item icon={MapPin} testid="pf-address">{p.address}</Item>}
          <Item icon={Clock} testid="pf-times">Check-in {p.check_in_time || "14:00"} · Check-out {p.check_out_time || "12:00"}</Item>
        </div>
        <div className="space-y-2">
          <p className="mb-1 font-semibold uppercase tracking-wide text-stone-500">{t("Kontak")}</p>
          {p.phone && <Item icon={Phone} testid="pf-phone"><a href={`tel:${p.phone}`} className="hover:text-white">{p.phone}</a></Item>}
          {wa && <Item icon={MessageCircle} testid="pf-whatsapp"><a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="hover:text-white">WhatsApp {p.whatsapp}</a></Item>}
          {p.public_email && <Item icon={Mail} testid="pf-email"><a href={`mailto:${p.public_email}`} className="hover:text-white">{p.public_email}</a></Item>}
          {p.instagram && <Item icon={Instagram} testid="pf-instagram"><a href={`https://instagram.com/${p.instagram.replace(/^@/, "")}`} target="_blank" rel="noreferrer" className="hover:text-white">@{p.instagram.replace(/^@/, "")}</a></Item>}
          <a href={findHref} data-testid="pf-find-booking" className="inline-block pt-1 font-semibold text-[#D9A066] hover:underline">{t("Cek Pesanan")}</a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-7xl px-6 py-4 text-xs text-stone-500">© {new Date().getFullYear()} {p.name} · Powered by Bedsolving Connect</p>
      </div>
    </footer>
  );
}
